export default class SelectTwoFix {
    constructor() {
        this.watchForChanges = this.watchForChanges.bind(this);
        this.observer = new MutationObserver(this.makeChanges.bind(this)); // Bind `this` to `makeChanges`

        this.watchForChanges();
    }

    watchForChanges(){
        const target = document.querySelector('body');

        if (!target) {
            console.error('Target element not found for MutationObserver');
            return;
        }

        const config = { childList: true }; // Include subtree
        this.observer.observe(target, config);   
    }

    fixPosition(el){
        const id = el.querySelector('ul').getAttribute('id');
        if(!id){
            console.error('Select2Fix: No id');
            return;
        }

        const origin = document.querySelector('.select2 span[aria-owns="'+id+'"]').closest('span.select2');
        if(!origin){
            console.error('Select2Fix: No origin');
            return;
        }

        const offset = this.getOffset(origin);
        el.style.top = offset.top + 'px';
    }

    makeChanges(mutations){
        mutations.forEach((mutation) => {
            if(mutation.addedNodes.length === 0) return;
            if(mutation.addedNodes[0].nodeType !== 1) return;
            if(!mutation.addedNodes[0].classList.contains('select2-container--open')) return;
            
            this.fixPosition(mutation.addedNodes[0]);
        });
    }

    getOffset(el) {
        const rect = el.getBoundingClientRect();
        return {
            left: rect.left + window.scrollX,
            top: rect.top + window.scrollY + el.clientHeight
        };
    }
}

if(document.querySelector('.js-select')) new SelectTwoFix();